import React, { useContext, useEffect, useState } from 'react';
import styles from './FreeSpins.module.scss';
import { Button, PlusLight, Table, Pagination, Modal } from 'esa-ui-library';
import { bonusPages, CAMPAIGN_SEARCH_TYPES, useStore } from '../../../common';
import {
	Header,
	PageAuth,
	PageContainer,
	Sidebar,
	SideMenu,
	Page,
	PageHeader,
	GlobalAlert,
	Filters,
} from '../../components';
import { PERMISSIONS } from '../../constants';
import { AuthContext } from '../../../logic';
import { getRows } from './RowProvider';
import { SearchFilter, PartnersFilter, StatusFilter, DateFilter } from '../../components/Filters/components';
import { SAVE } from '../GamblingReport/ReportTemplates/ReportTemplates.const';
import { CreateCampaignForm } from './components/CreateCampaignForm';

const FreeSpins = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const [loading, setLoading] = useState(false);
	const { campaigns, rows, columns, pagesTotal, currentPage, campaignsLoading, campaignForm } = state;
	const { user, token } = useContext(AuthContext);
	const [createModal, setCreateModal] = useState(false);
	const [isFormValid, setIsFormValid] = useState(false);

	const start_date = new Date().toISOString();
	const end_date = new Date().toISOString();

	useEffect(() => {
		dispatch('LOADING', true);
		dispatch('PARTNERS_INIT', user);
		dispatch('GAMES_INIT', { token, start_date, end_date });
		dispatch('STATUSES_INIT', { token });
		dispatch('CAMPAIGNS_INIT', {
			token,
			page: currentPage,
		});
		dispatch('FILTERS_INIT', {
			token,
			filters: ['providers', 'gameCategories', 'checksumStatuses', 'AAMS_types'],
		});
	}, []);

	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(campaigns, state.partners));
	}, [campaigns, state.partners]);

	const onPageChange = (page: number | string) => {
		dispatch('LOADING', true);
		dispatch('PAGE_UPDATE', { token, page });
	};

	const onCampaignAdd = () => {
		setCreateModal(true);
	};

	const onSubmit = async () => {
		setLoading(true);
		await dispatch('CAMPAIGN_ADD', { token, campaignForm });
		setCreateModal(false);
		dispatch('FORM_RESET');
		// dispatch('SELECT_GAME', { game: null });
		setLoading(false);
	};

	const onCloseCreateModal = () => {
		setCreateModal(false);
		dispatch('SELECT_GAME', { campaignForm: null });
		dispatch('FORM_RESET');
		dispatch('MESSAGE_INVALIDATE');
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth permission={PERMISSIONS.canViewOwnDetails}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={bonusPages} title='Bonuses' />
					</Sidebar>
					<Page>
						<PageHeader title='Free spins'>
							<Button primary small onClick={onCampaignAdd}>
								<PlusLight className={styles.AddCampaignIcon} />
								Create Campaign
							</Button>
						</PageHeader>
						<section className={styles.PageContent}>
							<Filters>
								<StatusFilter />
								<PartnersFilter />
								<DateFilter />
								<div style={{ marginLeft: 'auto' }}>
									<SearchFilter searchTypes={CAMPAIGN_SEARCH_TYPES} />
								</div>
							</Filters>
							{(!!campaigns.length || campaignsLoading) && (
								<>
									<Table
										titles={columns}
										data={rows}
										className={styles.CampaignTable}
										rowClassName={styles.CampaignRow}
										isLoading={campaignsLoading}
									/>
									<Pagination total={pagesTotal} current={currentPage} onChange={onPageChange} />
								</>
							)}
							{createModal && (
								<Modal
									title='Create Campaign'
									submitLabel={SAVE}
									primary
									onCancel={onCloseCreateModal}
									onSubmit={onSubmit}
									loading={!loading && !isFormValid}
								>
									<CreateCampaignForm onValidityChange={setIsFormValid} />
								</Modal>
							)}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { FreeSpins };
